export const BAD_REQUEST = 400
export const NOT_AUTHORIZED = 401
export const FORBIDDEN = 403
export const NOT_FOUND = 404
export const TOKEN_EXPIRED = 410
export const UNPROCESSABLE_ENTITY = 422

export const SERVER_ERROR = 500
export const _TIMEOUT = 504
export const _OK = 200
